/**
 * REST Client
 * Provides REST API methods (GET, POST, PUT, DELETE)
 */

import httpClient from './httpClient';
import { getApiEndpoint } from '../../config/tenantConfig';

/**
 * GET request
 * @param {string} apiName - API name (e.g., 'usereventapi')
 * @param {string} path - Request path
 * @param {Object} options - Request options
 * @param {Object} options.queryStringParameters - Query parameters
 * @param {Object} options.headers - Additional headers
 * @returns {Promise<any>} Response data
 * @throws {Error} If API endpoint not configured
 */
export const get = async (apiName, path, options = {}) => {
  const baseUrl = getApiEndpoint(apiName);

  if (!baseUrl) {
    throw new Error(`API '${apiName}' is not available in this environment`);
  }

  const url = `${baseUrl}${path}`;

  return await httpClient.get(url, {
    params: options.queryStringParameters,
    headers: options.headers
  });
};

/**
 * POST request
 * @param {string} apiName - API name
 * @param {string} path - Request path
 * @param {Object} options - Request options
 * @param {any} options.body - Request body
 * @param {Object} options.headers - Additional headers
 * @returns {Promise<any>} Response data
 */
export const post = async (apiName, path, options = {}) => {
  const baseUrl = getApiEndpoint(apiName);
  const url = `${baseUrl}${path}`;

  return await httpClient.post(url, options.body, {
    headers: options.headers
  });
};

/**
 * PUT request
 * @param {string} apiName - API name
 * @param {string} path - Request path
 * @param {Object} options - Request options
 * @param {any} options.body - Request body
 * @param {Object} options.headers - Additional headers
 * @returns {Promise<any>} Response data
 */
export const put = async (apiName, path, options = {}) => {
  const baseUrl = getApiEndpoint(apiName);
  const url = `${baseUrl}${path}`;

  return await httpClient.put(url, options.body, {
    headers: options.headers
  });
};

/**
 * DELETE request
 * @param {string} apiName - API name
 * @param {string} path - Request path
 * @param {Object} options - Request options
 * @param {Object} options.queryStringParameters - Query parameters
 * @param {Object} options.headers - Additional headers
 * @returns {Promise<any>} Response data
 */
export const del = async (apiName, path, options = {}) => {
  const baseUrl = getApiEndpoint(apiName);
  const url = `${baseUrl}${path}`;

  return await httpClient.delete(url, {
    params: options.queryStringParameters,
    headers: options.headers
  });
};
